// ────────────────────────────────────────────────────────────────
// Canonical channel labels — SINGLE SOURCE OF TRUTH (QA 1.5)
// ────────────────────────────────────────────────────────────────
// The same channel must read identically everywhere — campaign cards,
// the evaluate modal, the dashboard, the Result screen, the Share page
// and the PDF. Brand names are kept in their official Latin form (the
// client listed them this way); only "Other" is localized.
//
//   google   → Google Ads
//   tiktok   → TikTok
//   snapchat → Snapchat
//   meta     → Meta
//   other    → Other / أخرى
//
// A custom, user-typed channel (the "Other" free-text flow) is shown
// verbatim.
export const CANONICAL_CHANNELS = {
  google:   "Google Ads",
  tiktok:   "TikTok",
  snapchat: "Snapchat",
  meta:     "Meta",
  other:    "Other",
};

export function channelDisplay(ch, lang) {
  if (!ch) return "";
  const key = String(ch).toLowerCase();
  if (key === "other") return lang === "ar" ? "أخرى" : "Other";
  if (CANONICAL_CHANNELS[key]) return CANONICAL_CHANNELS[key];
  return ch; // custom user-supplied channel — render as typed
}